import normalize from 'json-api-normalizer';

export default class Folder {
	static from (jsonapi) {
		let key = 'folders'
		let normalizedJSONapi = normalize(jsonapi);
		if (!(Object.keys(normalizedJSONapi).includes(key))) return null;

		let keys = Object.keys(normalizedJSONapi[key]);
		if (keys.length > 0 && Array.isArray(jsonapi.data)) {
			/*
			let retVal = {};
			keys.forEach( function ( id ) {
				retVal[id] = Folder.make(normalizedJSONapi[key][id], normalizedJSONapi);
			});
			*/
			// TODO: Fix our code to use our standard Object type
			let retVal = []
			keys.forEach( function ( id ) {
				retVal.push(Folder.make(normalizedJSONapi[key][id], normalizedJSONapi));
			});

			return retVal;
		} else return Folder.make(normalizedJSONapi[key][keys[0]], normalizedJSONapi);
	}

	static make(jsonapi, normalizedJSONapi, noRelationships=0) {
		const { id, attributes } = jsonapi;
		return new Folder( Object.assign({}, {id: id}, attributes) );
	}

	constructor ({ id, name, ownerId, messageCount, unreadCount, parentFolderId, systemFolder, typeId }) {
		this.id               = id ? id : -1;
		this.name             = name ? name : '';
		this.owner_id         = ownerId ? ownerId : null;
		this.message_count    = messageCount ? messageCount : 0;
		this.unread_count     = unreadCount ? unreadCount : 0;
		this.parent_folder_id = parentFolderId ? parentFolderId : null;
		this.system_folder    = systemFolder ? systemFolder : false;
		this.type_id          = typeId ? typeId : 0;
	}

	toJSONapi () {
		let attributes = Object.assign({}, this);
		delete attributes.id;

		return {data: {type: "folders", id: this.id, attributes: attributes}};
	}
}
